import { render, staticRenderFns } from "./StatsPanel.vue?vue&type=template&id=0decf382&lang=pug&"
import script from "./StatsPanel.vue?vue&type=script&lang=ts&"
export * from "./StatsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StatsPanel.vue?vue&type=style&index=0&id=0decf382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports